/*
 * LHH collection template
 * - Pads the hero by the overlaid header's height
 * - 'Read more' on the hero body text
 * - Product / lifestyle image view toggle
 * - Floating filter + sort bar, applied without a page reload
 */
(function () {
  'use strict';

  if (window.lhhCollectionLoaded) return;
  window.lhhCollectionLoaded = true;

  var VIEW_KEY = 'lhh-collection-view';
  var filterTimer;
  var pendingRequest;

  /* Header height ------------------------------------------------------ */

  function setHeaderHeight() {
    var header = document.getElementById('SiteHeader');
    if (!header || header.classList.contains('site-header--stuck')) return;
    document.documentElement.style.setProperty('--lhh-header-height', header.offsetHeight + 'px');
  }

  /* Read more ---------------------------------------------------------- */

  function updateReadMore() {
    document.querySelectorAll('[data-lhh-readmore]').forEach(function (wrap) {
      var text = wrap.querySelector('[data-lhh-readmore-text]');
      var button = wrap.querySelector('[data-lhh-readmore-toggle]');
      if (!text || !button) return;
      if (wrap.classList.contains('is-expanded')) {
        button.hidden = false;
        return;
      }
      button.hidden = text.scrollHeight <= text.clientHeight + 1;
    });
  }

  function toggleReadMore(button) {
    var wrap = button.closest('[data-lhh-readmore]');
    var expanded = wrap.classList.toggle('is-expanded');
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    button.textContent = expanded ? button.dataset.labelLess : button.dataset.labelMore;
  }

  /* Image view --------------------------------------------------------- */

  function getStoredView() {
    try {
      return window.localStorage.getItem(VIEW_KEY);
    } catch (e) {
      return null;
    }
  }

  function applyView(view) {
    document.documentElement.classList.toggle('lhh-view-lifestyle', view === 'lifestyle');
    document.querySelectorAll('[data-lhh-view]').forEach(function (button) {
      button.setAttribute('aria-pressed', button.dataset.lhhView === view ? 'true' : 'false');
    });
  }

  function setView(view) {
    applyView(view);
    try {
      window.localStorage.setItem(VIEW_KEY, view);
    } catch (e) {}
  }

  /* Filter + sort panels ----------------------------------------------- */

  function openPanelName(container) {
    var panel = container.querySelector('[data-lhh-panel]:not([hidden])');
    return panel ? panel.dataset.lhhPanel : null;
  }

  function setPanel(container, name) {
    container.querySelectorAll('[data-lhh-panel]').forEach(function (panel) {
      panel.hidden = panel.dataset.lhhPanel !== name;
    });
    container.querySelectorAll('[data-lhh-toggle]').forEach(function (button) {
      button.setAttribute('aria-expanded', button.dataset.lhhToggle === name ? 'true' : 'false');
    });
    container.classList.toggle('is-panel-open', !!name);
  }

  function buildUrl(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (value !== '') params.append(key, value);
    });
    var query = params.toString();
    return form.getAttribute('action') + (query ? '?' + query : '');
  }

  function render(container, url) {
    var sectionId = container.dataset.sectionId;
    var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);

    if (pendingRequest) pendingRequest.abort();
    pendingRequest = new AbortController();
    container.classList.add('is-loading');

    fetch(fetchUrl, { signal: pendingRequest.signal })
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-lhh-collection]');
        if (!next) throw new Error('Collection section missing from response');

        // Keep the open panel, open filter groups and scroll position
        var panel = openPanelName(container);
        var openFilters = [];
        container.querySelectorAll('[data-lhh-filter]').forEach(function (details) {
          if (details.open) openFilters.push(details.dataset.lhhFilter);
        });
        var body = container.querySelector('[data-lhh-panel]:not([hidden]) [data-lhh-panel-body]');
        var scrollTop = body ? body.scrollTop : 0;

        container.innerHTML = next.innerHTML;

        container.querySelectorAll('[data-lhh-filter]').forEach(function (details) {
          details.open = openFilters.indexOf(details.dataset.lhhFilter) > -1;
        });
        setPanel(container, panel);
        var newBody = container.querySelector('[data-lhh-panel]:not([hidden]) [data-lhh-panel-body]');
        if (newBody) newBody.scrollTop = scrollTop;

        applyView(getStoredView() || 'product');
        container.classList.remove('is-loading');
        window.history.replaceState({}, '', url);
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return;
        window.location.href = url;
      });
  }

  /* Events ------------------------------------------------------------- */

  document.addEventListener('click', function (evt) {
    var target = evt.target;

    var readMore = target.closest('[data-lhh-readmore-toggle]');
    if (readMore) {
      toggleReadMore(readMore);
      return;
    }

    var viewButton = target.closest('[data-lhh-view]');
    if (viewButton) {
      setView(viewButton.dataset.lhhView);
      return;
    }

    var container = target.closest('[data-lhh-collection]');
    if (!container) return;

    var toggle = target.closest('[data-lhh-toggle]');
    if (toggle) {
      var name = toggle.dataset.lhhToggle;
      setPanel(container, openPanelName(container) === name ? null : name);
      return;
    }

    if (target.closest('[data-lhh-close]')) {
      setPanel(container, null);
      return;
    }

    var clear = target.closest('[data-lhh-clear]');
    if (clear) {
      evt.preventDefault();
      render(container, clear.getAttribute('href'));
    }
  });

  document.addEventListener('change', function (evt) {
    var form = evt.target.closest('[data-lhh-filter-form]');
    if (!form) return;

    var container = form.closest('[data-lhh-collection]');
    var isSort = evt.target.name === 'sort_by';

    clearTimeout(filterTimer);
    filterTimer = setTimeout(function () {
      if (isSort) setPanel(container, null);
      render(container, buildUrl(form));
    }, isSort ? 0 : 300);
  });

  document.addEventListener('submit', function (evt) {
    var form = evt.target.closest('[data-lhh-filter-form]');
    if (!form) return;
    evt.preventDefault();
    render(form.closest('[data-lhh-collection]'), buildUrl(form));
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Escape') return;
    document.querySelectorAll('[data-lhh-collection].is-panel-open').forEach(function (container) {
      setPanel(container, null);
    });
  });

  /* Init --------------------------------------------------------------- */

  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      setHeaderHeight();
      updateReadMore();
    }, 100);
  }

  function init() {
    setHeaderHeight();
    updateReadMore();
    applyView(getStoredView() || 'product');
  }

  init();
  window.addEventListener('resize', onResize);
  window.addEventListener('load', init);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(updateReadMore);
  document.addEventListener('shopify:section:load', init);
})();
